import { ERROR_MESSAGE } from "./actionTypes";

// eslint-disable-next-line
export default (state = {}, action) => {
  switch (action.type) {
    case ERROR_MESSAGE:
      return action.payload;
    default:
      return state;
  }
};
